import { useEffect, FC } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  children: React.ReactNode;
}

const Portal: FC<Props> = (props: Props) => {
  const { children } = props;

  const mount = document.getElementById('portal-root');
  const div = document.createElement('div');

  useEffect(() => {
    mount.appendChild(div);
    return () => {
      mount.removeChild(div);
    };
  }, [div, mount]);

  return createPortal(children, div);
};

export default Portal;
try {
    // @ts-ignore
    Portal.displayName = "Portal";
    // @ts-ignore
    Portal.__docgenInfo = { "description": "", "displayName": "Portal", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/Portal/Portal.tsx#Portal"] = { docgenInfo: Portal.__docgenInfo, name: "Portal", path: "src/shared/hoc/Portal/Portal.tsx#Portal" };
}
catch (__react_docgen_typescript_loader_error) { }